import { Link, LinkProps } from '@mui/material';
import React from 'react';
import { joinMultipleStyle } from '../../Utils/ScssUtils';
import './LinkStyle.scss';

function CustomLink({ className, ...props }: LinkProps): JSX.Element {
    console.log(joinMultipleStyle('customLink', className));
    return (
        <Link
            className={joinMultipleStyle('customLink', className)}
            {...props}
        ></Link>
    );
}

export default CustomLink;
